import { render, staticRenderFns } from "./Pos_monitor.vue?vue&type=template&id=280c3b66&scoped=true&"
import script from "./Pos_monitor.vue?vue&type=script&lang=js&"
export * from "./Pos_monitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c3b66",
  null
  
)

export default component.exports